








































































































































































































































import { Vue, Component, Prop, Watch, Mixins, Ref } from "vue-property-decorator";
// import Password from "vue-password-strength-meter";
// import zxcvbn from "zxcvbn";
import { VIPUser, db, busy, auth, VIPUserRest, toaster, IVIPUser, DBType } from "@/loader";
import { VIPUserViewMixin, VIPUserEditMixin } from "@/mixins/VIPUserMixin";
import UserEdit from "../../component/user/UserEdit.vue";

// type UserProperties = "username" | "email" | "first_name" | "last_name" | "password" | "confirmPassword" | "roles";

// interface ZxcvbnResult {
// 	password: string;
// 	guesses: number;
// 	guesses_log10: number;
// 	sequence: {
// 		pattern: string;
// 		i: number;
// 		j: number;
// 		token: string;
// 		matched_word: string;
// 		rank: number;
// 		dictionary_name: string;
// 		reversed: boolean;
// 		l33t: boolean;
// 		base_guesses: number;
// 		uppercase_variations: number;
// 		l33t_variations: number;
// 		guesses: number;
// 		guesses_log10: number;
// 	}[];
// 	calc_time: number;
// 	crack_times_seconds: {
// 		online_throttling_100_per_hour: number;
// 		online_no_throttling_10_per_second: number;
// 		offline_slow_hashing_1e4_per_second: number;
// 		offline_fast_hashing_1e10_per_second: number;
// 	};
// 	crack_times_display: {
// 		online_throttling_100_per_hour: string;
// 		online_no_throttling_10_per_second: string;
// 		offline_slow_hashing_1e4_per_second: string;
// 		offline_fast_hashing_1e10_per_second: string;
// 	};
// 	score: number;
// 	feedback: {
// 		warning: string;
// 		suggestions: string[];
// 	};
// }

@Component({
	components: {
		// "v-password": Password,
		UserEdit,
	},
})
export default class User extends Mixins(VIPUserViewMixin({
	redirection: { name: "Users" },
	loadMessage: "Chargement de l'utilisateur ...",
})) {
	public saved(item: VIPUser) {
		if (item && item.id !== this.id) {
			item.password = null;
			item.confirmPassword = null;
			this.$router.push({ name: "User", params: { id: item.id } });
		}
	}

	public removed() {
		this.$router.push({ name: "Users" });
	}

	// public get isSelf(): boolean {
	// 	return auth.user?.id === this.id || false;
	// }

	// public passwordTime: string = "";

	// @Ref()
	// public editor!: UserEdit;

	// public get passwordInfo(): ZxcvbnResult {
	// 	return zxcvbn(this.item.password);
	// }

	// public focused = {
	// 	username: false,
	// 	email: false,
	// 	first_name: false,
	// 	last_name: false,
	// 	password: false,
	// 	confirmPassword: false,
	// 	roles: false,
	// };

	// public feedbacks = {
	// 	username: "L'identifiant doit être entre 1 et 60 caractères",
	// 	email: "L'email n'est pas valide",
	// 	first_name: "",
	// 	last_name: "",
	// 	password: "",
	// 	confirmPassword: "Les deux mots de passe ne sont pas identiques.",
	// 	roles: "Au moins un rôle doit être actif."
	// };

	// public get states() {
	// 	return {
	// 		username: this.focused.username ? this.item?.username?.length > 0 && this.item?.username?.length < 60 : null,
	// 		email: this.focused.email ? /^[a-zA-Z0-9_.+-]+@[a-zA-Z0-9-]+\.[a-zA-Z0-9-.]+$/.test(this.item?.email) : null,
	// 		first_name: this.focused.first_name ? true : null,
	// 		last_name: this.focused.last_name ? true : null,
	// 		password: this.focused.password ? !this.item.password || !this.feedbacks.password : null,
	// 		confirmPassword: this.item.password && this.focused.confirmPassword ? this.item.password === this.item.confirmPassword : null,
	// 		roles: this.focused.roles ? !!this.item.roles.length : null,
	// 	};
	// }

	// public get isAdmin(): boolean {
	// 	return this.item?.isAdmin || false;
	// }

	// public get names(): string[] {
	// 	let names: string[] = [];
	// 	if (!this.item) {
	// 		return names;
	// 	}

	// 	names.push(this.item.username);
	// 	if (this.item.first_name) {
	// 		names.push(this.item.first_name);
	// 	}
	// 	if (this.item.last_name) {
	// 		names.push(this.item.last_name);
	// 	}
	// 	if (this.item.first_name && this.item.last_name) {
	// 		names.push(`${this.item.first_name} ${this.item.last_name}`);
	// 		names.push(`${this.item.last_name} ${this.item.first_name}`);
	// 		names.push(`${this.item.first_name?.substr(0, 1)}. ${this.item.last_name}`);
	// 	}

	// 	return names;
	// }

	// public caps = [
	// 	{
	// 		name: "Utilisateur", read: "list_users", create: null, edit: "edit_users", delete: "remove_users",
	// 	},
	// 	{
	// 		name: "Client", read: "read_vip_company", create: "create_vip_company", edit: "edit_vip_company", delete: "delete_vip_company",
	// 	},
	// 	{
	// 		name: "Contact", read: "read_vip_contact", create: "create_vip_contact", edit: "edit_vip_contact", delete: "delete_vip_contact",
	// 	},
	// 	{
	// 		name: "Projet", read: "read_vip_project", create: "create_vip_project", edit: "edit_vip_project", delete: "delete_vip_project",
	// 	},
	// 	{
	// 		name: "Réalisation", read: "assign_vip_production", create: "manage_vip_production", edit: "edit_vip_production", delete: "delete_vip_production",
	// 	},
	// 	{
	// 		name: "IP", read: "read_vip_ip", create: "create_vip_ip", edit: "edit_vip_ip", delete: "delete_vip_ip",
	// 	},
	// 	{
	// 		name: "IP - Equivalence", read: "read_vip_ip_equivalence", create: "create_vip_ip_equivalence", edit: "edit_vip_ip_equivalence", delete: "delete_vip_ip_equivalence",
	// 	},
	// 	{
	// 		name: "Certificat", read: "read_vip_certificate", create: "create_vip_certificate", edit: "edit_vip_certificate", delete: "delete_vip_certificate",
	// 	},
	// 	{
	// 		name: "Certificat - IP", read: "read_vip_certificate_ip", create: "create_vip_certificate_ip", edit: "edit_vip_certificate_ip", delete: "delete_vip_certificate_ip",
	// 	},
	// 	{
	// 		name: "Certificat - Evènements", read: "read_vip_certificate_event", create: "create_vip_certificate_event", edit: "edit_vip_certificate_event", delete: "delete_vip_certificate_event",
	// 	},
	// 	{
	// 		name: "Capacité", read: "read_vip_capability", create: "create_vip_capability", edit: "edit_vip_capability", delete: "delete_vip_capability",
	// 	},
	// 	{
	// 		name: "Capacité - Certificats", read: "read_vip_capability_certificate", create: "create_vip_capability_certificate", edit: "edit_vip_capability_certificate", delete: "delete_vip_capability_certificate",
	// 	},
	// ];

	// public save() {
	// 	if (!this.item || !this.canEdit) {
	// 		return;
	// 	}
	// 	if (!this.check()) {
	// 		toaster.toast({ message: "Certaines informations ne sont pas valides.", variant: "warning", noAutoHide: false });
	// 		return;
	// 	}

	// 	busy.start("Sauvegarde de l'utilisateur ...");
	// 	let p = this.item.id < 0 ? VIPUserRest.create : VIPUserRest.update;
	// 	p(this.item).then(result => {
	// 		if (result.success) {
	// 			this.item.password = null;
	// 			this.item.confirmPassword = null;
	// 			this.changed = false;
	// 			this.unfocusAll();
	// 			if (this.id < 0 && result.item) {
	// 				this.$router.push({ name: "User", params: { id: result.item.id } });
	// 			}
	// 		}
	// 	}).finally(() => {
	// 		busy.stop();
	// 	});
	// }

	// public loginKeypress(event: KeyboardEvent) {
	// 	if (!/[a-z0-9@._-]/.test(event.key)) {
	// 		event.preventDefault();
	// 	}
	// }

	// public passwordFeedback(result: { suggestions: string[], warning: string }) {
	// 	this.feedbacks.password = (result.suggestions.map(s => s.endsWith(".") ? s : s + ".").join(" ") + " " + result.warning).trim();
	// }

	// @Watch("item.password")
	// public passwordChanged(newValue?: string | null, oldValue?: string | null) {
	// 	if (newValue && newValue !== oldValue && this.passwordInfo) {
	// 		let { suggestions, warning } = this.passwordInfo.feedback;
	// 		suggestions.unshift(warning);
	// 		this.feedbacks.password = suggestions.filter(x => !!x).map(s => s.endsWith(".") ? s : s + ".").join(" ").trim();

	// 		let values = Object.entries(this.passwordInfo.crack_times_seconds).sort(([,aSec], [,bSec]) => aSec - bSec);
	// 		let [min,] = values[0];
	// 		let [max,] = <[string, number]>values.pop();
	// 		min = this.passwordInfo.crack_times_display[min];
	// 		max = this.passwordInfo.crack_times_display[max];
	// 		this.passwordTime = `Il faudra ${min === max ? min : `entre ${min} et ${max}`} pour découvrir votre mot de passe.`;
	// 	}
	// }
}
